import type {
  AgentFilterListWidget,
  AgentRefreshEditorWidget,
  AgentWidget,
} from 'aevocam-rest-api-spec'
import { AgentFilterList } from './AgentFilterList'
import { AgentRefreshEditor } from './AgentRefreshEditor'

type Props = {
  widget: AgentWidget
  fromStream?: boolean
  setArticleIds?: (articleIds?: string[]) => void
  onRefreshEditor?: () => void
}

export function AgentWidgetView({
  widget,
  fromStream,
  setArticleIds,
  onRefreshEditor,
}: Props) {
  switch (widget.type) {
    case 'filterList':
      return (
        <AgentFilterList
          widget={widget as AgentFilterListWidget}
          fromStream={fromStream}
          setArticleIds={setArticleIds}
        />
      )
    case 'refreshEditor':
      return (
        <AgentRefreshEditor
          widget={widget as AgentRefreshEditorWidget}
          fromStream={fromStream}
          onRefreshEditor={onRefreshEditor}
        />
      )
    default:
      return null
  }
}
